<onsip-header-main>
  <onsip-header-page-title>E911</onsip-header-page-title>
</onsip-header-main>

<main>
  <div class="mat-headline-4 e911-text e911-invoiced-prepaid">
    {{ "ONSIP_I18N.CONTACT_US_TO_ENABLE_E911" | translate }}
  </div>
  <div class="mat-body-2 e911-text">
    {{
      "ONSIP_I18N.BECAUSE_YOUR_PAYMENTS_ARE_PROCESSED_VIA_INVOICE_THE_E911_SERVICE_WILL_NEED_TO_BE_ENABLED_MANUALLY_THROUGH_ONSIPS_BILLING_DEPARTMENT"
        | translate
    }}
  </div>

  <button
    mat-flat-button
    color="primary"
    [routerLink]="views.CONTACT_SALES"
    class="e911-contact-sales"
  >
    {{ "ONSIP_I18N.CONTACT_BILLING" | translate }}
  </button>

  <div class="mat-body-2 e911-text">
    {{
      "ONSIP_I18N.REQUIRES_CC__PSTN_BALANCE_FREE_TO_ENABLE__USERBASED_COST_OF_180_PER_MONTH_FOR_EACH_USER_ADDED_TO_A_LOCATION"
        | translate
    }}
  </div>
</main>
